import { Quote } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

// Real owner photo (source of truth). Employee portraits remain placeholders.
const OWNER_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_amra-showcase/artifacts/rvtt8j0x_WhatsApp%20Image%202026-07-21%20at%2022.47.40.jpeg";

const EMPLOYEE_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_amra-showcase/artifacts/h3am6x4u_WhatsApp%20Image%202026-07-22%20at%2000.15.39.jpeg";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative scroll-mt-20 px-6 py-24 lg:px-10 lg:py-32"
    >
      <div className="mx-auto max-w-7xl">
        <Reveal className="max-w-2xl">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-teal">
            Testimonials
          </span>
          <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-[#0a0a0a] sm:text-5xl">
            From the people who run it.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#52525b] sm:text-lg">
            The team and leadership behind AMRA Decorations, in their own words.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* Featured owner testimonial */}
          <Reveal className="lg:col-span-7">
            <div
              data-testid="owner-testimonial"
              className="relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border border-black/[0.07] bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.03)] sm:p-10"
            >
              <div
                className="pointer-events-none absolute inset-0 -z-0"
                style={{
                  background:
                    "radial-gradient(60% 60% at 100% 0%, rgba(13,148,136,0.05) 0%, rgba(255,255,255,0) 60%)",
                }}
              />
              <Quote className="relative h-9 w-9 text-brand-teal/30" />
              <blockquote className="relative mt-6 space-y-4 text-[15px] leading-relaxed text-[#3f3f46]">
                <p>
                  “Running a decoration business involves managing thousands of
                  products and customers. Earlier, we relied on multiple software
                  subscriptions and a lot of manual work.
                </p>
                <p>
                  With AMRA AI Business OS, we replaced multiple tools with one
                  system, reducing our software costs. When suppliers send large
                  Excel catalogues, the AI checks for missing information and
                  duplicate products before importing them. This saves us time
                  and prevents mistakes.
                </p>
                <p>
                  The AI dashboard doesn&apos;t just show reports. It tells us which
                  products are selling well, identifies dead stock, reminds us to
                  follow up with seasonal customers, highlights revenue
                  opportunities, and even suggests when to reorder fast-moving
                  products. That helps us make better business decisions every
                  day.
                </p>
                <p>
                  For our business, this isn&apos;t just billing software—it&apos;s an AI
                  assistant that helps us run the business more efficiently.”
                </p>
              </blockquote>
              <div className="relative mt-8 flex items-center gap-5">
                <img
                  src={OWNER_IMG}
                  alt="Amra Decorations business owner portrait"
                  className="h-28 w-24 rounded-xl object-cover object-top shadow-md ring-1 ring-black/[0.06]"
                />
                <div>
                  <p className="font-heading text-base font-bold text-[#0a0a0a]">
                    Amra Decorations
                  </p>
                  <p className="font-mono text-xs uppercase tracking-[0.12em] text-[#a1a1aa]">
                    Business Owner
                  </p>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Employee using the product */}
          <Reveal delay={0.1} className="lg:col-span-5">
            <div
              data-testid="employee-testimonials"
              className="flex h-full flex-col rounded-2xl border border-black/[0.07] bg-[#fafafa] p-8 sm:p-10"
            >
              <p className="font-heading text-xl font-bold tracking-tight text-[#0a0a0a]">
                Employee using AMRA AI Business OS
              </p>
              <div
                data-testid="employee-card-0"
                className="mt-6 overflow-hidden rounded-xl border border-black/[0.06] bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
              >
                <img
                  src={EMPLOYEE_IMG}
                  alt="Employee using the AMRA AI Billing OS to bill the product"
                  className="w-full object-cover"
                  loading="lazy"
                />
              </div>
              <p className="mt-5 text-sm leading-relaxed text-[#52525b]">
                Employee using the AMRA AI BILLING OS to bill the product
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
